import styled, { css, keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const spinLoader = keyframes`
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(360deg)
  }
`;

export const LoginHeader = styled.header`
  background-color: #fff;
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 80px;
  height: 80px;

  img {
    width: 214px;
  }
`;

export const Container = styled.div`
  height: calc(100vh - 118px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const LoginWrapper = styled.div`
  width: 90%;
  max-width: 408px;
  h1 {
    color: ${({ theme }) => theme.colors.darkGrey};
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 28px;
  }

  @media (min-width: 768px) {
    h1 {
      font-size: 1.75rem;
    }
  }
`;

export const LoginInner = styled.div`
  background-color: #fff;
  padding: 50px 35px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  @media (min-width: 768px) {
    padding: 70px 55px;
  }
`;

export const InputWrap = styled.div<{
  readonly isFilled: boolean;
  readonly isError?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 40px;
  border-bottom: solid 1px ${({ theme }) => theme.colors.lightGrey};
  margin-bottom: 20px;
  transition: 0.3s;

  label {
    color: ${({ theme }) => theme.colors.lightGrey};
    position: absolute;
    display: block;
    height: auto;
    top: 15px;
    font-size: 16px;
    text-align: left;
    white-space: nowrap;
    cursor: text;
    transition: all 0.3s ease;
    z-index: 5;
  }

  input {
    position: absolute;
    display: block;
    width: 100%;
    height: 22px;
    bottom: 0;
    left: 0;
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkGrey};
    z-index: 1;
    &:-webkit-autofill {
      background-color: white !important;
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
    &:focus {
      & + label {
        top: 0;
        font-size: 0.75rem;
        transition: 0.2s;
      }
    }
  }

  ${({ isError, theme }) =>
    isError &&
    `
    border-bottom-color: ${theme.colors.red}
  `}

  ${({ isFilled }) =>
    isFilled &&
    `
    label {
      top: 0;
      font-size: 0.75rem;
      transition: 0.2s;
    }
  `}
`;

export const Button = styled.button<{
  readonly isLoading: boolean;
}>`
  outline: none;
  width: 100%;
  height: 50px;
  background-color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  color: #fff;
  border: 0;
  cursor: pointer;
  font-size: 0.875rem;
  transition: 0.5s;
  display: block;
  margin: 48px auto 28px;

  ${({ isLoading }) =>
    isLoading &&
    css`
      transition: width 0.5s ease, height 0.5s, padding 0.5s, color 0.3s,
        font-size 0s linear 0.4s, border-radius 0.5s linear 0.2s,
        opacity 0.3s linear 0.3s;
      width: 50px;
      height: 50px;
      color: transparent;
      font-size: 0;
      padding: 0;
      border-radius: 50px;
      outline: none;
      opacity: 0;
    `}
`;

export const ProgressLoading = styled.div<{
  readonly isLoading: boolean;
}>`
  position: absolute;
  display: block;
  width: 50px;
  height: 50px;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  border-radius: 50px;
  border: solid 5px ${({ theme }) => theme.colors.extraLightGrey};
  box-sizing: border-box;
  opacity: 0;
  visibility: hidden;
  &::after,
  &::before {
    content: '';
    position: absolute;
    width: 50px;
    height: 50px;
    top: -5px;
    left: -5px;
    border-radius: 50px;
    border: solid 5px transparent;
    box-sizing: border-box;
  }

  &::before {
    border-top-color: ${({ theme }) => theme.colors.primary};
  }

  &::before {
    border-bottom-color: ${({ theme }) => theme.colors.primary};
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      transition: opacity 0.3s linear 0.4s, visibility 0.1s;
      opacity: 1;
      visibility: visible;
      &::before,
      &::after {
        animation: ${spinLoader} 1s linear infinite;
      }
    `}
`;

export const ForgotPasswordLink = styled(Link)`
  text-align: center;
  display: block;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.875rem;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorLabel = styled.span`
  position: absolute;
  color: ${({ theme }) => theme.colors.red};
  font-size: 12px;
  top: 110%;
`;

export const ErrorMessage = styled.div`
  color: #fff;
  font-weight: bold;
  background-color: ${({ theme }) => theme.colors.red};
  font-size: 0.75rem;
  text-align: center;
  padding: 12px;
  position: fixed;
  width: 100%;
  top: 78px;
`;
